import { connect } from 'react-redux';
import IAppState from '../../IAppState';
import {IFindJobComponentPropsData, IFindJobComponentPropsFunctions} from "./IFindJobComponentProps";
import FindJobComponent from "./FindJobComponent";
import Actions from "../../act-main";
import { withRouter } from 'react-router-dom';
import { clientUrlPrefix } from '../../settings';

function handleSubmit(dispatch, jobId: string, browserHistory) {
    dispatch(Actions.clickFindJobBtn(jobId));
    if (jobId !== "") {
        browserHistory.push(`${clientUrlPrefix}/job/${encodeURIComponent(jobId)}`);
    }
}

const mapStateToProps = (state: IAppState): IFindJobComponentPropsData => {
    return {};
}

const mapDispatchToProps = (dispatch): IFindJobComponentPropsFunctions => ({
    handleSubmit: (jobId: string, browserHistory) => handleSubmit(dispatch, jobId, browserHistory),
})

const FindJobContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FindJobComponent));

export default FindJobContainer;
